import React from 'react';
import { Box, Typography, IconButton, Skeleton, Chip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import StarIcon from '@mui/icons-material/Star';
import { useDeleteRegionImageMutation } from '../Service/extendedRegionsApi';
import { UploadedRegionImagesGalleryProps } from '../Types/regionTypes';
import { getImageDisplayUrl } from '../../Images/Utils/imageUrlHelper';

const UploadedRegionImagesGallery = ({
    images,
    isLoading,
    isError,
    regionId,
    onDeleteSuccess,
}: UploadedRegionImagesGalleryProps) => {
    const [deleteImage] = useDeleteRegionImageMutation();

    const handleDelete = async (imageId: string) => {
        try {
            await deleteImage({ imageId, regionId }).unwrap();
            onDeleteSuccess?.();
        } catch (err) {
            console.error('[UploadedRegionImagesGallery] Błąd usuwania zdjęcia:', err);
        }
    };

    return (
        <Box mt={4}>
            <Typography variant="subtitle1" fontWeight={500} gutterBottom>
                Wgrane zdjęcia:
            </Typography>

            {isLoading && (
                <Box sx={{ display: 'flex', gap: 2 }}>
                    {Array.from({ length: 3 }).map((_, i) => (
                        <Skeleton key={i} variant="rectangular" width={120} height={120} />
                    ))}
                </Box>
            )}

            {isError && <Typography color="error">Nie udało się załadować zdjęć regionu.</Typography>}

            {images.length > 0 && (
                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                    {images.map((img) => (
                        <Box
                            key={img.id}
                            sx={{
                                position: 'relative',
                                width: 120,
                                height: 120,
                                borderRadius: 2,
                                overflow: 'hidden',
                                boxShadow: '0 0 4px rgba(0,0,0,0.2)',
                            }}
                        >
                            <img
                                src={getImageDisplayUrl(img)}
                                alt={img.altText || `region-image-${img.id}`}
                                title={img.altText || ''}
                                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                            />

                            {img.isPrimary && (
                                <Chip
                                    icon={<StarIcon />}
                                    label="Główne"
                                    size="small"
                                    color="primary"
                                    sx={{
                                        position: 'absolute',
                                        top: 4,
                                        left: 4,
                                        fontSize: '0.7rem',
                                    }}
                                />
                            )}

                            <IconButton
                                size="small"
                                onClick={() => handleDelete(img.id)}
                                sx={{
                                    position: 'absolute',
                                    top: 2,
                                    right: 2,
                                    backgroundColor: 'rgba(255,255,255,0.7)',
                                    '&:hover': { backgroundColor: 'rgba(255,255,255,0.9)' },
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    ))}
                </Box>
            )}
        </Box>
    );
};

export default UploadedRegionImagesGallery;
